var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      class: _vm.classNames,
      attrs: {
        clearable: "",
        disabled: _vm.disabled,
        filterable: "",
        loading: _vm.loading,
        placeholder: _vm.placeholder,
        size: _vm.size
      },
      on: { change: _vm.onChanged },
      model: {
        value: _vm.reference,
        callback: function($$v) {
          _vm.reference = $$v
        },
        expression: "reference"
      }
    },
    _vm._l(_vm.referenceList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name, value: item.value }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }